var viewModelBase = require('../tk/view_model/base.js');

// The only reason we're keeping this file around is because the backend font
// file detail page uses it for the tabs at the bottom of the page.
//
// For example:
//   /variations/33852/files/1000055569
module.exports = viewModelBase.create({
  include: ['Tabs'],

  init: function(options) {
    if (options.initialTab) {
      this.currentTab(options.initialTab);
    }
  },
}, {
  'Tabs': require('../tk/view_model/tabs.js')
});
